import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

import { oppositeTheme, themeOption } from "./theme-options";
import { useAccountTheme } from "./use-account-theme";

/** Icon button that flips between light and dark; saved to the account when signed in. */
export function ThemeToggle({ className }: { className?: string }) {
  const { resolvedTheme, toggleTheme } = useAccountTheme();
  const target = themeOption(oppositeTheme(resolvedTheme));
  const label = `Switch to ${target.label.toLowerCase()} theme`;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="ghost" size="icon-sm" aria-label={label} onClick={toggleTheme} className={className}>
          <target.icon />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
